import { useI18n } from "vue-i18n";
import type { NotificaApi } from "~~/shared/data-model/notifica_api";

/** Azioni sulle notifiche comuni a tendina e pagina: segnare tutte come lette e aprire l'impianto (che segna la notifica come letta). Gli errori finiscono in un toast. */
export function useNotificheAzioni() {
  const store = useNotificheStore();
  const { toastError } = useToastHelper();
  const { t } = useI18n();

  async function segnaTutte(): Promise<void> {
    if (!(await store.segnaTutteLette())) toastError(t("centro_notifiche.errore_azione"));
  }

  async function apriNotifica(n: NotificaApi): Promise<void> {
    if (!n.letta_il && !n.archiviata) void store.segnaLette([n.id]);
    await navigateTo(`/impianti/${n.id_impianto}`);
  }

  return { segnaTutte, apriNotifica };
}
